import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--extranarrow _mb-6 _mt-6" }
const _hoisted_2 = { class: "gfu-content-head" }
const _hoisted_3 = {
  class: "gfu-hd gfu-hd--h1",
  "data-qa": "terms-of-service:PageTitle"
}
const _hoisted_4 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.Resources.TermsOfService.PageHeader), 1 /* TEXT */)
    ]),
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "gfu-bt gfu-bt--b1",
          innerHTML: $props.termsOfServiceDescription
        }, null, 8 /* PROPS */, _hoisted_4)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}